import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Breadcrumbs, BreadcrumbItem, ButtonIcon, SecondaryButton } from '@hz-design-system/web-ui';

import Classes from './AutosBreadcrumbs.module.scss';

const AutosBreadcrumbs = () => {
  const { t } = useI18nContext();

  return (
    <>
      <div className={Classes.root}>
        <SecondaryButton onClick={() => window.history.back()} className={Classes.wide}>
          <ButtonIcon name="back" />
          {t('common:page.navigation.back')}
        </SecondaryButton>

        <Breadcrumbs>
          <BreadcrumbItem icon="home" link="/">
            {t('common:page.navigation.home')}
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage={true}>{'Ontdek meer Auto’s'}</BreadcrumbItem>
        </Breadcrumbs>
      </div>
    </>
  );
};

export default AutosBreadcrumbs;
